var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-section-detail",
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: "Vak detail", icon: "magicon-tiles" } },
        [
          _c(
            "ui-button",
            {
              attrs: { slot: "left", color: "medium", type: "bordered" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
              slot: "left",
            },
            [_vm._v("Terug")]
          ),
          _c(
            "ui-button",
            {
              attrs: { color: "highlight-1" },
              on: {
                click: function ($event) {
                  return _vm.exportExcel()
                },
              },
            },
            [_vm._v("Exporteren")]
          ),
        ],
        1
      ),
      !_vm.loading
        ? _c("pm-parcel-detail", {
            attrs: {
              parcel: _vm.section.parcel,
              sections: [_vm.section],
              editable: _vm.$can("MUTATE_SECTIONS"),
              deletable: _vm.$can("MUTATE_SECTIONS"),
            },
            on: {
              delete: _vm.onActionDeleted,
              "cohort-close": _vm.onCohortClosed,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }